import React, { useState, useEffect } from "react";
import { FormControl } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import debounce from "lodash/debounce";

const DEFAULT_FALLBACK_DATE = dayjs("2000-01-01");

const CustomDatePicker = ({
  value: propValue,
  onChange,
  onBlur,
  rule,
  minDate,
  format = "DD/MM/YYYY",
  mt = 0,
  ...props
}) => {
  const [value, setValue] = useState(DEFAULT_FALLBACK_DATE);
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");

  useEffect(() => {
    if (propValue) {
      setValue(dayjs(propValue));
    } else if (minDate) {
      const parsedMin = dayjs(minDate);
      setValue(parsedMin);
      onChange?.(parsedMin);
    } else {
      setValue(DEFAULT_FALLBACK_DATE);
      onChange?.(DEFAULT_FALLBACK_DATE);
    }
  }, [propValue, minDate]);

  const handleValidation = debounce((val) => {
    if (rule) {
      const { isValid, errorMessage } = rule(val);
      setError(!isValid);
      setHelperText(errorMessage);
    }
  }, 300);

  const handleChange = (date) => {
    setValue(date);
    onChange?.(date);
    handleValidation(date);
  };

  const handleBlur = () => {
    onBlur?.();
    handleValidation(value);
  };

  return (
    <FormControl fullWidth error={error}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          format={format}
          minDate={minDate ? dayjs(minDate) : undefined}
          slotProps={{
            textField: {
              fullWidth: true,
              helperText,
            },
          }}
          sx={{
            mt,
            "& .MuiOutlinedInput-root": {
              borderRadius: 20,
              minHeight: { xs: "44px", sm: "54px" },
            },
            "& .MuiOutlinedInput-input": {
              fontSize: { xs: "13px", sm: "15px" },
              padding: { xs: "12px 14px !important", sm: "16.5px 14px !important" },
            },
          }}
          {...props}
        />
      </LocalizationProvider>
    </FormControl>
  );
};

export default CustomDatePicker;